import { Link } from "react-router-dom";
import { NAV_LINKS, BOOKING_URL, CVR_NUMBER } from "@/data/content";
import { MaskedLines, Reveal } from "@/components/motion";
import ButtonLink from "@/components/ButtonLink";

const Footer = () => (
  <footer data-testid="site-main-footer" className="border-t border-darkborder bg-obsidian text-[#F5F5F0]">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <h2 data-testid="footer-brand-title" className="font-serif text-5xl leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl">
        <MaskedLines
          mode="view"
          lines={["Hjernen er ikke statisk.", <span key="t" className="italic font-light text-[#A3A299]">Den kan trænes.</span>]}
        />
      </h2>
      <Reveal delay={0.2} className="mt-10">
        <ButtonLink to={BOOKING_URL || "/kontakt"} variant="light" testId="footer-cta-book-btn">
          Book en indledende samtale
        </ButtonLink>
      </Reveal>

      <div className="mt-20 grid grid-cols-1 gap-12 border-t border-darkborder pt-14 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#575752]">Navigation</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-${l.id}`}
                  className="text-sm text-[#A3A299] transition-colors duration-300 hover:text-[#F5F5F0]"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div data-testid="footer-contact-details">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#575752]">Kontakt</p>
          <ul className="mt-5 space-y-3 text-sm text-[#A3A299]">
            <li>Gudenåvej 60, Voervadsbro</li>
            <li>8660 Skanderborg</li>
            <li>
              Telefon:{" "}
              <a
                href="tel:+4593935006"
                data-testid="footer-phone-link"
                className="transition-colors duration-300 hover:text-[#F5F5F0]"
              >
                93 93 50 06
              </a>
            </li>
            <li>
              E-mail:{" "}
              <a
                href="mailto:info@centerforhjerneregulering.dk"
                className="transition-colors duration-300 hover:text-[#F5F5F0]"
              >
                info@centerforhjerneregulering.dk
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#575752]">Sessioner</p>
          <ul className="mt-5 space-y-3 text-sm text-[#A3A299]">
            <li>Træning og samtaler</li>
            <li>foregår efter aftale.</li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#575752]">Centret</p>
          <ul className="mt-5 space-y-3 text-sm text-[#A3A299]">
            <li>Center for Hjerneregulering</li>
            {CVR_NUMBER && <li data-testid="footer-business-cvr">CVR: {CVR_NUMBER}</li>}
            <li>Danmark</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 border-t border-darkborder pt-8">
        <p data-testid="footer-medical-disclaimer" className="max-w-3xl text-xs leading-relaxed text-[#575752]">
          Neurofeedback hos Center for Hjerneregulering er en træningsmetode med fokus på hjernens evne
          til selvregulering. Træningen tilpasses individuelt, og responsen varierer fra person til
          person. Derfor tager hvert forløb udgangspunkt i den enkeltes respons og udvikling.
        </p>
        <div className="mt-6 flex flex-col gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[#575752] sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 Center for Hjerneregulering</span>
          <span>Hjernen er ikke statisk. Den kan trænes.</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
